import type { ReactNode } from 'react';
import { useSyncExternalStore } from 'react';

type Props = {
	children: ReactNode;
	placeholder?: ReactNode;
};

export function NoSSR({ children, placeholder = <></> }: Props) {
	const isClient = useSyncExternalStore(
		() => () => {},
		() => true,
		() => false
	);

	return isClient ? children : placeholder;
}
